
const ENV = "PROD";
const API_BASE_PATH = "/api/v1/";
// const API_URL = 'ENV === "LOCAL_CLIENT_ONLY" ? API_BASE_PATH : process.env.REACT_APP_API_URL' + API_BASE_PATH;
const API_URL = 'https://electionapi.deshsanchar.com' + API_BASE_PATH;
// const ASSET_HOST_BASE_URL = ENV === "LOCAL_CLIENT_ONLY" || ENV === "LOCAL" ? "" : process.env.REACT_APP_ASSET_HOST_BASE_URL;
// const ASSET_HOST_BASE_URL = process.env.REACT_APP_ASSET_HOST_BASE_URL;
const ASSET_HOST_BASE_URL = 'https://electionassets.deshsanchar.com/election2079';

const PIE_CHART_COLORS = ["green", "red", "yellow", "gray"];
const CLOSE_MARGIN_THRESHOLD = 1000;
const PR_THERESHOLD_PERCENT = { 0: 0.03, 1: 0.015, 2: 0.015, 3: 0.015, 4: 0.015, 5: 0.015, 6: 0.015, 7: 0.015 };
const COMBINE_PR = true;

const combinedParties = ["CNP", "NAP", "NGGP", "NNJP"];
const combinedParties2 = ["NPDP", "SUP", "CPNS"];
const combinedParties3 = ["CPNMC", "SPN"];
const toBeExcludedParties = ["NGGP", "NNJP", "NAP", "SUP", "CPNS", "SPN"];

// from federal to provincial
const PROPORTIONAL_SEAT = { 0: 110, 1: 37, 2: 43, 3: 44, 4: 24, 5: 35, 6: 16, 7: 21 };
const TOTAL_SEAT = { federal: 110, provincial: 220 };

const LONGNAMES = ["kavrepalanchowk", "lalitpur", "bhaktapur", "kathmandu", "nawalparasieast", "rukumwest", "nawalparasiwest", "rukumeast"];

const SHORT_NAMES = {
  kavrepalanchowk: { name_np: "काभ्रे", name_en: "Kavre" },
  lalitpur: { name_np: "ल.", name_en: "La" },
  bhaktapur: { name_np: "भ.", name_en: "Bha" },
  kathmandu: { name_np: "का.", name_en: "Ka" },
  nawalparasieast: { name_np: "नवल प.पू.", name_en: "PaPaPu" },
  rukumwest: { name_np: "रुकुम प.", name_en: "Rukum W" },
  nawalparasiwest: { name_np: "नवल प.प.", name_en: "NaPaPa" },
  rukumeast: { name_np: "रुकुम पू.", name_en: "Rukum E" },
};

const TOP_PARTY_COUNT = 4;

const INDEPENDENT_SYMBOL_2079 = [
  { symbol: "triangle", candidates: ["rupandehi_1_ghanshyam_bhusal"] },
  { symbol: "syringe", candidates: ["dadeldhura_1_sagar_dhakal", "kathmandu_5_hemraj_thapa"] },
  { symbol: "tubel", candidates: ["rauthat_3_prabhu_shah", "morang_5_yogendra_mandal", "rauthat_2_kiran_kumar_sah", "bardiya_2_lalvir_chaudhary"] },
  { symbol: "cross_khukuri", candidates: ["jhapa_4_khushbu_oli", "jhapa_2_bhadra_prasad_nepal"] },
  { symbol: "camera", candidates: ["kathmandu_5_shree_ram_gurung"] },
  { symbol: "selroti", candidates: ["kathmandu_5_ranju_neupane"] },
  { symbol: "jaar", candidates: ["kathmandu_7_yadhab_lal_kayastha"] },
  { symbol: "clock_tower", candidates: ["kathmandu_7_ram_bir_manandhar"] },
  { symbol: "scissors", candidates: ["tanahun_1_govinda_raj_joshi"] },
  { symbol: "fish", candidates: ["sarlahi_4_amresh_kumar_singh"] },
];

const POPULAR_REGIONS_FEDERAL_2079 = {
  heavy_weights: [
    { region: "jhapa-5", party: "cpnuml" },
    { region: "chitwan-2", party: "rsp" },
    { region: "sarlahi-4", party: "nc" },
    { region: "rukumeast-1", party: "nkp" },
    { region: "sunsari-1", party: "ssp2" },
    { region: "kathmandu-3", party: "unp2" },
    { region: "rauthat-1", party: "nkp" },
    { region: "jhapa-3", party: "ndp" },
    { region: "morang-6", party: "nc" },
    { region: "rukumwest-1", party: "pldp" },
    { region: "chitwan-3", party: "nkp" },
    { region: "rupandehi-2", party: "cpnuml" },
    { region: "bhaktapur-2", party: "cpnuml" },
    { region: "dhanusa-3", party: "rsp" },
    { region: "achham-2", party: "rsp" },
    { region: "baitadi-1", party: "nc" },
    { region: "jhapa-2", party: "rsp" },
    { region: "gorkha-1", party: "rsp" },
    { region: "kanchanpur-2", party: "rsp" },
    { region: "tanahun-1", party: "rsp" },
    { region: "gulmi-1", party: "rsp" },
    { region: "dang-2", party: "cpnuml" },
    { region: "jumla-1", party: "ndp" },
    { region: "rolpa-1", party: "nkp" },
    { region: "kathmandu-5", party: "cpnuml" },
    { region: "kathmandu-9", party: "rsp" },
    { region: "nuwakot-1", party: "nc" },
    { region: "lalitpur-3", party: "rsp" },
    { region: "saptari-2", party: "pop" },
    { region: "nawalparasiwest-1", party: "nc" },
    { region: "kathmandu-8", party: "rsp" },
    { region: "gorkha-2", party: "rsp" },
    { region: "saptari-3", party: "pspn" },
    { region: "achham-1", party: "nkp" },
    { region: "dhading-1", party: "rsp" },
    { region: "jajarkot-1", party: "nkp" },
    { region: "kathmandu-4", party: "cpnuml" },
    { region: "kathmandu-1", party: "ndp" },
    { region: "morang-3", party: "nc" },
    { region: "gulmi-2", party: "cpnuml" },
    { region: "lamjung-1", party: "cpnuml" },
    { region: "sarlahi-3", party: "nkp" },
    { region: "morang-2", party: "nc" },
    { region: "dhanusa-4", party: "cpnuml" },
    { region: "palpa-2", party: "cpnuml" },
    { region: "lalitpur-2", party: "rsp" },
    { region: "kanchanpur-1", party: "nkp" },
  ],
  battle_grounds: [
    { region: "chitwan-2", parties: ["nc", "cpnuml", "rsp"] },
    { region: "makwanpur-1", parties: ["rdp", "nc", "cpnuml"] },
    { region: "kathmandu-1", parties: ["nc", "ndp", "rsp"] },
    { region: "dadeldhura-1", parties: ["nc", "i2"] },
    { region: "jhapa-3", parties: ["nc", "ndp"] },
    { region: "kathmandu-4", parties: ["nc", "cpnuml"] },
    { region: "kathmandu-5", parties: ["nc", "cpnuml"] },
    { region: "gulmi-2", parties: ["cpnus", "cpnuml"] },
    { region: "lalitpur-1", parties: ["nc", "cpnuml"] },
    { region: "dhausa-4", parties: ["nc", "cpnuml"] },
    { region: "rupandehi-1", parties: ["cpnuml", "i1"] },
    { region: "rupandehi-3", parties: ["nc", "ndp"] },
    { region: "lamjung-1", parties: ["cpnmc", "cpnuml"] },
    { region: "sarlahi-2", parties: ["cpnmc", "dspn"] },
    { region: "dang-1", parties: ["cpnuml", "cpnus"] },
    { region: "gulmi-1", parties: ["nc", "cpnuml"] },
    { region: "morang-6", parties: ["nc", "cpnuml"] },
    { region: "jhapa-1", parties: ["nc", "cpnuml"] },
    { region: "nawalparasiwest-1", parties: ["nc", "jppn"] },
    { region: "siraha-2", parties: ["pspn", "nc"] },
    { region: "saptari-2", parties: ["pspn", "pop"] },
    { region: "syangja-2", parties: ["cpnuml", "nc"] },
  ],
  close_margins: [
    { region: "kathmandu-1", parties: ["nc", "ndp"] },
    { region: "kathmandu-9", parties: ["cpnuml", "rsp"] },
    { region: "bhaktapur-2", parties: ["nc", "cpnuml"] },
    { region: "illam-2", parties: ["cpnuml", "nc"] },
    { region: "morang-1", parties: ["cpnuml", "nc"] },
    { region: "morang-2", parties: ["cpnuml", "nc"] },
    { region: "dhankuta-1", parties: ["cpnuml", "nc"] },
    { region: "siraha-2", parties: ["pspn", "nc"] },
    { region: "siraha-3", parties: ["cpnuml", "cpnmc"] },
    { region: "sunsari-4", parties: ["cpnuml", "nc"] },
    { region: "dhanusa-2", parties: ["cpnuml", "nc"] },
    { region: "dhanusa-4", parties: ["cpnuml", "nc"] },
    { region: "bara-2", parties: ["pspn", "cpnmc"] },
    { region: "manang-1", parties: ["nc", "cpnuml"] },
    { region: "gulmi-1", parties: ["nc", "cpnuml"] },
    { region: "kapilvastu-2", parties: ["nc", "cpnuml"] },
    { region: "dang-2", parties: ["cpnuml", "cpnmc"] },
    { region: "bardiya-2", parties: ["i2", "cpnmc"] },
    { region: "dailekh-1", parties: ["cpnus", "cpnuml"] },
    { region: "dailekh-2", parties: ["nc", "cpnuml"] },
    { region: "bajhang-1", parties: ["cpnuml", "cpnus"] },
    { region: "kailali-5", parties: ["cpnuml", "nc"] },
    { region: "baitadi-1", parties: ["cpnuml", "cpnmc"] },
  ],
};

const POPULAR_REGIONS_PROVINCIAL_2079 = {
  heavy_weights: [
    { region: "bhojpur-1.1", party: "cpnus" },
    { region: "siraha-4.1", party: "cpnmc" },
    { region: "dhanusa-4.2", party: "cpnus" },
    { region: "sarlahi-1.1", party: "dspn" },
    { region: "parsa-1.2", party: "pspn" },
    { region: "parsa-2.2", party: "i2" },
    { region: "sindhuli-2.2", party: "cpnmc" },
    { region: "dhading-2.2", party: "cpnmc" },
    { region: "nuwakot-1.1", party: "cpnmc" },
    { region: "chitwan-2.2", party: "cpnuml" },
    { region: "humla-1.2", party: "nc" },
    { region: "manang-1.2", party: "i1" },
    { region: "bajura-1.1", party: "cpnuml" },
    { region: "bajura-1.2", party: "nc" },
    { region: "dadeldhura-1.1", party: "cpnmc" },
  ],
  battle_grounds: [
    { region: "bhojpur-1.1", parties: ["cpnus", "cpnuml"] },
    { region: "dhanusa-4.2", parties: ["cpnus", "cpnnuml"] },
    { region: "bajura-1.2", parties: ["nc", "cpnnuml"] },
    { region: "sarlahi-1.1", parties: ["dspn", "cpnmc"] },
    { region: "parsa-1.2", parties: ["pspn", "nc"] },
    { region: "siraha-4.1", parties: ["cpnmc", "cpnuml"] },
  ],
  close_margins: [
    { region: "terhathum-1.1", parties: ["nc", "cpnuml"] },
    { region: "terhathum-1.2", parties: ["cpnmc", "cpnuml"] },
    { region: "panchthar-1.1", parties: ["cpnmc", "cpnuml"] },
    { region: "sankhuwasabha-1.1", parties: ["cpnmc", "cpnuml"] },
    { region: "sankhuwasabha-1.2", parties: ["cpnus", "cpnuml"] },
    { region: "okhaldhunga-1.1", parties: ["nc", "cpnuml"] },
    { region: "morang-2.1", parties: ["cpnmc", "cpnuml"] },
    { region: "morang-4.1", parties: ["nc", "cpnuml"] },
    { region: "siraha-1.1", parties: ["nc", "cpnuml"] },
    { region: "siraha-2.1", parties: ["pop", "pspn"] },
    { region: "siraha-4.2", parties: ["dspn", "pspn"] },
    { region: "mahottari-1.1", parties: ["dspn", "cpnuml"] },
    { region: "mahottari-3.1", parties: ["pspn", "dspn"] },
    { region: "mahottari-3.2", parties: ["dspn", "i4"] },
    { region: "bara-3.1", parties: ["cpnmc", "cpnuml"] },
    { region: "bara-3.2", parties: ["pspn", "cpnuml"] },
    { region: "saptari-3.2", parties: ["pop", "pspn"] },
    { region: "chitwan-1.2", parties: ["cpnus", "cpnuml"] },
    { region: "chitwan-2.2", parties: ["nc", "cpnuml"] },
    { region: "chitwan-3.2", parties: ["cpnmc", "ndp"] },
    { region: "makwanpur-1.2", parties: ["nc", "cpnuml"] },
    { region: "kathmandu-4.1", parties: ["nc", "ndp"] },
    { region: "kathmandu-5.1", parties: ["nc", "ndp"] },
    { region: "kathmandu-6.1", parties: ["nc", "cpnuml"] },
    { region: "kathmandu-7.2", parties: ["nc", "cpnuml"] },
    { region: "kathmandu-9.1", parties: ["ndp", "cpnuml"] },
    { region: "tanahun-2.2", parties: ["nc", "cpnuml"] },
    { region: "myagdi-1.1", parties: ["cpnmc", "cpnuml"] },
    { region: "myagdi-1.2", parties: ["cpnmc", "cpnuml"] },
    { region: "lamjung-1.2", parties: ["nc", "cpnuml"] },
    { region: "syangja-1.2", parties: ["nc", "cpnuml"] },
    { region: "kaski-1.2", parties: ["nc", "cpnuml"] },
    { region: "bardiya-1.1", parties: ["nc", "cpnuml"] },
    { region: "kapilvastu-2.1", parties: ["nc", "cpnuml"] },
    { region: "kapilvastu-2.2", parties: ["nc", "cpnuml"] },
    { region: "kapilvastu-3.1", parties: ["dspn", "cpnuml"] },
    { region: "kapilvastu-3.2", parties: ["ndp", "cpnuml"] },
    { region: "rukumeast-1.1", parties: ["i1", "cpnmc"] },
    { region: "banke-1.2", parties: ["nc", "cpnuml"] },
    { region: "nawalparasiwest-2.1  ", parties: ["i3", "ndp"] },
    { region: "arghakhanchi-1.1", parties: ["npf", "cpnuml"] },
    { region: "dailekh-2.2", parties: ["cpnmc", "cpnuml"] },
    { region: "surkhet-2.1", parties: ["nc", "cpnuml"] },
    { region: "dolpa-1.2", parties: ["cpnmc", "cpnuml"] },
    { region: "doti-1.1", parties: ["nc", "cpnuml"] },
    { region: "doti-1.2", parties: ["cpnmc", "cpnuml"] },
    { region: "dadeldhura-1.2", parties: ["nc", "i1"] },
    { region: "kanchanpur-1.2", parties: ["nc", "cpnuml"] },
    { region: "kanchanpur-2.1", parties: ["cpnmc", "cpnuml"] },
    { region: "baitadi-1.2", parties: ["nc", "cpnuml"] },
    { region: "kailali-4.2", parties: ["nc", "cpnuml"] },
    { region: "kailali-5.1", parties: ["cpnmc", "cpnuml"] },
  ],
};

const TRANSLATIONS = {
  nepal: { en: "Nepal", np: "नेपाल" },
  election: { en: "Election", np: "निर्वाचन" },
  win: { en: "Win", np: "विजयी" },
  lead: { en: "Lead", np: "अगाडि" },
  province: { en: "Province", np: "प्रदेश" },
  district: { en: "District", np: "जिल्ला" },
  search: { en: "Search", np: "खोज्‍नुहोस्" },
  total_ERN: { en: "Total Election Region", np: "जम्मा निर्वाचन क्षेत्र" },
  total: { en: "Total", np: "जम्मा" },
  ern: { en: "Region Number", np: "निर्वाचन क्षेत्र" },
  party: { en: "Party", np: "पार्टी" },
  vote: { en: "Vote", np: "मत" },
  count_done: { en: "Declared", np: "मतगणना समाप्त" },
  count_not_started: { en: "Not Counted", np: "मतगणना नगरीइको" },
  couting: { en: "Couting", np: "मतगणना जारी" },
  elected: { en: "Elected", np: "निर्वाचित" },
  federal: { en: "Federal", np: "प्रतिनिधिसभा" },
  provincial: { en: "Provincial", np: "प्रदेशसभा" },
  and: { en: "and", np: "र" },
  proportional: { en: "Proportional", np: "समानुपातिक" },
  direct: { en: "Direct", np: "प्रत्यक्ष" },
  result: { en: "Result", np: "परिणाम" },
  summary: { en: "Summary", np: "सारांश" },
  details: { en: "Details", np: "विवरण" },
  region: { en: "Region", np: "क्षेत्र" },
  seat: { en: "Seat", np: "सिट" },
  nation_wide_data: { en: "Nation Wide Data", np: "देशव्यापी विवरण" },
  static_data: { en: "Static Data", np: "स्थिर डाटा" },
  major_parties: { en: "Major Parties", np: "प्रमुख दलहरू" },
  top_10_parties: { en: "Top 10 Parties", np: "शीर्ष १० पार्टीहरू" },
  top_candidates: { en: "Top Candidates", np: "शीर्ष उम्मेदवारहरू" },
  parties: { en: "Party", np: "पार्टीहरू" },
  candidates: { en: "Candidates", np: "उम्मेदवारहरू" },
  candidate: { en: "Candidate", np: "उम्मेदवार" },
  homepage: { en: "Home", np: "गृहपृष्ठ" },
  candidate_list: { en: "Candidate List", np: "उम्मेदवारहरूको सूची" },
  candidate_profile: { en: "Candidate Profile", np: "उम्मेदवार विवरण" },
  party_name: { en: "Party Name", np: "पार्टीको नाम" },
  election_symbol: { en: "Election Symbol", np: "चुनाव चिन्ह" },
  photo: { en: "Photo", np: "फोटो" },
  candidancy_for: { en: "Candidancy For", np: "उम्मेदवारी" },
  candidancy: { en: "Candidancy", np: "उम्मेदवारी" },
  background: { en: "Background", np: "पृष्ठभूमि" },
  party_list: { en: "Party List", np: "पार्टी सूची" },
  color: { en: "Color", np: "रंग" },
  sn: { en: "S.N.", np: "क्र.सं." },
  no_record_found: { np: "कुनै रेकर्ड फेला परेन", en: "No Record Found" },
  not_found_title: { np: "उफ्! केही भेटिएन", en: "OOPS! NOTHING WAS FOUND" },
  not_found_desc: { np: "तपाईंले खोज्नु भएको पृष्ठ हटाइएको, परिवर्तन गरिएको वा अस्थायी रूपमा अनुपलब्ध हुन सक्छ।", en: "The page you are lookig for might have been removed, changed or temporarily unavailable." },
  not_found_link: { np: "कृपया [link] मा फर्कनुहोस्।", en: "Please return to the []" },
  parliament_member: { np: "प्रतिनिधि सभा सदस्य", en: "Member of House of Representative" },
  province_member: { np: "प्रदेश सभा सदस्य", en: "Member of House of Province" },
  total_record: { np: "जम्मा रेकर्ड", en: "Total Record" },
  table_size: { np: "तालिका आकार", en: "Table Size" },
  first: { np: "पहिलो", en: "first" },
  prev: { np: "अघिल्लो", en: "prev" },
  next: { np: "अर्को", en: "next" },
  last: { np: "अन्तिम", en: "last" },
  other: { np: "अन्य", en: "Other" },
  candidate_analytics: { np: "उम्मेदवार विश्लेषण", en: "Candidate Analytics" },
  analytics: { np: "विश्लेषण", en: "Analytics" },
  number: { np: "संख्या", en: "Number" },
  male: { np: "पुरुष", en: "Male" },
  female: { np: "महिला", en: "Female" },
  age: { np: "उमेर", en: "Age" },
  gender: { np: "लिङ्ग", en: "Gender" },
  religion: { np: "धर्म", en: "Religion" },
  ethnic_group: { np: "समावेशी समूह", en: "Ethnic Group" },
  academic_qualification: { np: "शैक्षिक योग्यता", en: "Academic Qualification" },
  khas_arya: { np: "खस आर्य", en: "Khas Arya" },
  janajati: { np: "जनजाति", en: "Janajati" },
  dalit: { np: "दलित", en: "Dalit" },
  madhesi: { np: "मधेसी", en: "Madhesi" },
  hindu: { np: "हिन्दु", en: "Hindu" },
  christian: { np: "क्रिश्चियन", en: "Christian" },
  buddhist: { np: "बौद्ध", en: "Buddhist" },
  muslim: { np: "मुस्लिम", en: "Muslim" },
  all_parties: { np: "सबै दलहरू", en: "All Parties" },
  select_region: { np: "निर्वाचन क्षेत्र छान्नुहोस्", en: "Select Region" },
  select_district: { np: "जिल्ला छान्नुहोस्", en: "Select District" },
  select_province: { np: "प्रदेश छान्नुहोस्", en: "Select Province" },
  below_primary: { np: "प्राथमिक भन्दा तल", en: "Below Primary" },
  primary: { np: "प्राथमिक तह", en: "Primary" },
  lower_secondary: { np: "निम्न माध्यामिक तह", en: "Lower Secondary" },
  secondary: { np: "माध्यामिक तह", en: "Secondary" },
  higher_secondary: { np: "उच्च माध्यामिक तह", en: "Higher Secondary" },
  intermediate: { np: "प्रमाणपत्र तह", en: "Intermediate" },
  bachelor: { np: "स्नातक तह", en: "Bachelor's Degree" },
  master: { np: "स्नाकोत्तर तह", en: "Master's Degree" },
  mphil: { np: "दर्शनशास्त्रमा स्नाकोत्तर", en: "Master of Philosophy" },
  phd: { np: "विद्यावारिधी", en: "Doctor of Philosophy" },
  last_updated: { np: "पछिल्लो अद्यावधिक", en: "Last Updated" },
  year: { np: "वर्ष", en: "year" },
  years: { np: "वर्ष", en: "years" },
  month: { np: "महिना", en: "month" },
  months: { np: "महिना", en: "months" },
  week: { np: "हप्ता", en: "week" },
  weeks: { np: "हप्ता", en: "weeks" },
  day: { np: "दिन", en: "day" },
  days: { np: "दिन", en: "days" },
  hour: { np: "घण्टा", en: "hr" },
  hours: { np: "घण्टा", en: "hours" },
  minute: { np: "मिनेट", en: "min" },
  minutes: { np: "मिनेट", en: "minutes" },
  second: { np: "सेकेन्ड", en: "sec" },
  seconds: { np: "सेकेन्ड", en: "seconds" },
  ago: { np: "पहिले", en: "ago" },
  total_candidate: { np: "जम्मा उम्मेदवार", en: "Total Candidate" },
  load_more: { np: "थप लोड गर्नुहोस्", en: "see more" },
  show_less: { np: "कम देखाउनुहोस्", en: "see less" },
  for_detail_election_result: { np: "निर्वाचनको विस्तृत परिणामको लागि", en: "for more the details of election result." },
  click_here: { np: "यहाँ क्लिक गर्नुहोस्।", en: "Click here" },
  coming_soon: { np: "निर्वाचन परिणाम पोर्टल चाँडै आउँदै छ।", en: "Election Result portal coming soon." },
  wip: { np: "काम भइरहेको छ।", en: "Work in progress." },
  remaining: { np: "बाँकी", en: "Remaining" },
  election_countdown: { np: "चुनाव आउन", en: "Election Countdown" },
  district_view: { np: "जिल्ला अनुसार नक्सा", en: "District View" },
  region_view: { np: "क्षेत्र अनुसार नक्सा", en: "Region View" },
  short_name: { np: "संक्षिप्त नाम", en: "Short Name" },
  total_voter: { np: "कुल मतदाता", en: "Total Voter" },
  area: { np: "क्षेत्रफल", en: "Area" },
  voting_booth: { np: "मतदान केन्द्र", en: "Voting Booth" },
  sq_km: { np: "वर्ग किमी", en: "Sq. km" },
  election_expense_limit: { np: "निर्वाचन खर्च सीमा", en: "Election Expense Limit" },
  nrs: { np: "रु", en: "NRs." },
  heavy_weights: { np: "रोचक क्षेत्र", en: "Heavy Weight" },
  heavy_weights_candidates: { np: "रोचक क्षेत्रहरु", en: "Interesting Regions" },
  battle_ground: { np: "महाभिडन्त", en: "Battleground" },
  battle_grounds_title: { np: "रोचक क्षेत्रहरू", en: "Hot Seats" },
  close_margins_title: { np: "कडा प्रतिस्पर्धा क्षेत्रहरू", en: "Hot Seats" },
  view_all: { np: "सबै विवरण", en: "View All" },
  president: { np: "प्रमुख", en: "President" },
  all_candidates: { np: "सबै उम्मेदवारहरू", en: "All Candidates" },
  close_margin: { np: "क्लोज मार्जिन", en: "Close Margin" },
  diff: { np: "मतान्तर", en: "diff" },
  n_above: { np: "[n] भन्दा माथि", en: "Above [n]" },
  n_below: { np: "[n] भन्दा कम", en: "Below [n]" },
  independent: { np: "स्वतन्त्र", en: "Independent" },
};

const otherParty = {
  id: 0,
  name_np: "अन्य",
  name_en: "Other",
  short_name_np: "",
  short_name_en: "",
  code: "O",
  symbol: ASSET_HOST_BASE_URL + "/images/parties/O.png",
  color: "#123456",
};

const independentParty = {
  id: -1,
  name_np: "स्वतन्त्र",
  name_en: "Independent",
  short_name_np: "",
  short_name_en: "",
  code: "I",
  symbol: ASSET_HOST_BASE_URL + "/images/parties/I.png",
  color: "#96e637",
};

export { ENV, API_BASE_PATH, ASSET_HOST_BASE_URL, API_URL, PIE_CHART_COLORS, LONGNAMES, SHORT_NAMES, TOTAL_SEAT, COMBINE_PR, CLOSE_MARGIN_THRESHOLD, PR_THERESHOLD_PERCENT, PROPORTIONAL_SEAT, POPULAR_REGIONS_FEDERAL_2079, POPULAR_REGIONS_PROVINCIAL_2079, INDEPENDENT_SYMBOL_2079, TOP_PARTY_COUNT, TRANSLATIONS, otherParty, independentParty, combinedParties, combinedParties2, combinedParties3, toBeExcludedParties };
